<template>
    <rkm-form ref="Form">
        <rkm-area
            type="section"
            title="Buscar exames retroativos agendados"
        >
            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-date-picker
                        range
                        :range-inline="false"
                        start-label="Período de"
                        end-label="Até"
                        v-model="agendamento.periodo"
                        :max-date="data.model.dataAtual"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="unidadeExecutante"
                        label="Unidade executante"
                        show-default-option
                        text-field="unidadeNome"
                        v-model="agendamento.unidadeId"
                        default-option-text="Selecione"
                        value-field="unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        textField="nomeInfraestrutura"
                        v-model="agendamento.infraestruturaId"
                        valueField="infraestruturaId"
                        show-default-option
                        :disabled="!agendamento.unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        label="Número do agendamento"
                        number
                        v-model="agendamento.agendamentoNumero"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="3">
                    <rkm-form-select
                        :options="medicoSolicitante"
                        label="Médico solicitante"
                        show-default-option
                        text-field="medicoNome"
                        v-model="agendamento.medicoId"
                        value-field="medicoId"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :options="profissionais"
                        label="Profissional"
                        show-default-option
                        text-field="profissionalNome"
                        v-model="agendamento.profissionalId"
                        value-field="profissionalId"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-select
                        label="Grupo de exames"
                        :options="grupoExame"
                        v-model="agendamento.exameId"
                        value-field="exameId"
                        text-field="grupoExameNome"
                        show-default-option
                    />
                </rkm-col>

                <rkm-col cols="2" >
                    <rkm-form-checkbox
                        v-model="agendamento.urgente"
                        :label="false"
                        inline
                    >
                        Agendamento urgente
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col cols="2" >
                    <rkm-button
                        :label="false"
                        @click.stop="resetForm"
                        color="secondary"
                        class="float-right"
                    >
                        Limpar
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="$refs.Form.validate(search)"
                        color="primary"
                        class="mr-2 float-right"
                    >
                        Buscar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-area>
     </rkm-form>
</template>

<script>

// Moment.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { repository, error, object, data, stringCase } from '@/mixins'

export default {
    computed:{
        unidadeExecutante(){

            return this.data.form.unidadeExecutante ? this.data.form.unidadeExecutante : []
        },
        infraestruturas() {

            if (this.agendamento.unidadeId) {

                let infraestruturaPrincipal = this.unidadeExecutante.find(u => u.unidadeId === this.agendamento.unidadeId)

                if (infraestruturaPrincipal) {

                    this.loadInfraestrutura(infraestruturaPrincipal.infraestruturas)

                    return infraestruturaPrincipal.infraestruturas
                }
            }

            return []
        },
        profissionais(){

            const profissionalOrigem = []

            if (this.data.model.agendamentos) {

                this.data.model.agendamentos.map(profissional => {

                    if (profissionalOrigem) {

                        let verifyProfissional = profissionalOrigem.find(u => u.profissionalId === profissional.profissionalId)

                        if (!verifyProfissional) {

                            profissionalOrigem.push({

                                profissionalId: profissional.profissionalId,
                                profissionalNome: profissional.profissionalNome,
                            })
                        }
                    }
                })
            }

            return profissionalOrigem
        },
        medicoSolicitante(){

            const medicoOrigem = []

            if (this.data.model.agendamentos) {

                this.data.model.agendamentos.map(medico => {

                    if (medicoOrigem) {

                        let verifyMedico = medicoOrigem.find(u => u.medicoId === medico.medicoId)

                        if (!verifyMedico) {

                            medicoOrigem.push({

                                medicoId: medico.medicoId,
                                medicoNome: medico.medicoNome,
                            })
                        }
                    }
                })
            }

            return medicoOrigem
        },
        grupoExame(){

            const exameOrigem = []

            if (this.data.model.agendamentos) {

                this.data.model.agendamentos.map(grupo => {

                    if (exameOrigem) {

                        let verifyGrupo = exameOrigem.find(u => u.exameId === grupo.grupoExameId)

                        if (!verifyGrupo) {

                            exameOrigem.push({

                                exameId: grupo.grupoExameId,
                                grupoExameNome: grupo.grupoExameNome,
                            })
                        }
                    }
                })
            }

            return exameOrigem
        },
        validations() {
            return {
                diasSemana: { required: true },
                periodo: {
                    start: { required: true },
                    end: { required: true },
                },
            }
        },
    },
    created() {

        this.repositories = {
            agendamento: this.getConectaSusRepository('exameImagem.agendamentoRetroativo')
        }
    },
    data:() => ({
        cadastro:[],
        agendamento: {
            data: null,
            agendamentoNumero: null,
            exameId: null,
            infraestruturaId: null,
            unidadeId: null,
            profissionalId: null,
            urgente: false,
            medicoId: null,
            periodo: {
                start: null,
                end: null,
            },
        },
        dataAtual: '',
    }),
    methods:{
        ...mapActions(['setLoading', 'unsetLoading']),
        loadInfraestrutura(infraestrutura) {

            const infraestruturaPrincipal = infraestrutura.find(u => u.principal)

            if (infraestruturaPrincipal) {
                this.agendamento.infraestruturaId = infraestruturaPrincipal.infraestruturaId;
            }
        },
        search() {

            this.validate()
                .then(valid => {

                    if (!valid) return

                    let buscaAgendamento = this.data.model.agendamentos

                    if(this.agendamento.unidadeId){

                       buscaAgendamento = buscaAgendamento.filter(agendamento => agendamento.unidadeId == this.agendamento.unidadeId)
                    }

                    if(this.agendamento.exameId){

                       buscaAgendamento = buscaAgendamento.filter(agendamento => agendamento.grupoExameId == this.agendamento.exameId)
                    }

                    if(this.agendamento.profissionalId){

                       buscaAgendamento = buscaAgendamento.filter(agendamento => agendamento.profissionalId == this.agendamento.profissionalId)
                    }

                    if(this.agendamento.medicoId){

                       buscaAgendamento = buscaAgendamento.filter(agendamento => agendamento.medicoId == this.agendamento.medicoId)
                    }

                    if(this.agendamento.urgente){

                       buscaAgendamento = buscaAgendamento.filter(agendamento => agendamento.urgente == this.agendamento.urgente)
                    }

                    if(this.agendamento.agendamentoNumero){

                       buscaAgendamento = buscaAgendamento.filter(agendamento => agendamento.agendamentoNumero == this.agendamento.agendamentoNumero)
                    }

                    if (this.agendamento.periodo.start && this.agendamento.periodo.end){

                        const start = moment(this.agendamento.periodo.start).subtract(1, 'day')
                        const end = moment(this.agendamento.periodo.end).add(1, 'day')

                        buscaAgendamento = buscaAgendamento.filter(agendamento =>

                            moment(new Date(agendamento.data.split("-").join("/")), 'DD/MM/YYYY').isBetween(start, end)
                        )
                    }

                    this.data.model.agendamentosNotSave = buscaAgendamento
            })
        },
        resetForm() {

            this.agendamento.exameId = null
            this.agendamento.profissionalId = null
            this.agendamento.medicoId = null
            this.agendamento.unidadeId = null
            this.agendamento.infraestruturaId = null
            this.agendamento.agendamentoNumero = null
            this.data.model.agendamentosNotSave = null

            this.$nextTick()
                .then(() => {
                    this.setDefaultValues()
                })
        },
        setDefaultValues() {

            this.agendamento.periodo.start = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
            this.agendamento.periodo.end = moment(this.data.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        validate() {

            return this.$refs.Form.validate()
        },
    },
    mixins: [ repository, error, object, data, stringCase ],
    props: {
        data: { type: Object, required: true },
    },
}
</script>